import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue';
import { onBeforeMount, ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import EnFilterButtonBase from 'Components/datagrid/filterButtons/EnFilterButtonBase';
import EnFilterTypeSelectButton from 'Components/datagrid/filterButtons/EnFilterTypeSelectButton';
import EnTextField from 'Components/inputs/EnTextField/EnTextField.vue';
import { sleep } from 'Js/utils/sleep';
import { FilterType } from 'Js/enums/filterType.js';
import { FilterEvent } from '../types/filterEvent';
import { useResetFilter } from '../composables/useFilterReset';
import { useFilter } from '../composables/filterButtonComposable';
/**
 * A filter button for a single value with search input.
 */
export default /*@__PURE__*/ _defineComponent({
    __name: 'EnSearchFilterButton',
    props: /*@__PURE__*/ _mergeModels({
        // TODO(VHA) Rename to `key`.
        id: { String },
        filterTypeSelectionVisible: Boolean,
        type: String,
        initialType: {
            type: String,
            default: FilterType.Equal,
        },
        hint: String,
        label: String,
        applyButtonText: String,
        resetButtonText: String,
        noFilterText: String,
    }, {
        "modelValue": {},
        "modelModifiers": {},
        "openOnRender": {},
        "openOnRenderModifiers": {},
    }),
    emits: /*@__PURE__*/ _mergeModels(['update:modelValue', 'update:openOnRender', FilterEvent.Input, 'update:type', FilterEvent.FilterUpdated, FilterEvent.FilterReset], ["update:modelValue", "update:openOnRender"]),
    setup(__props, { expose: __expose, emit: __emit }) {
        __expose();
        const componentProps = __props;
        const { t } = useI18n();
        const modelValue = _useModel(__props, 'modelValue');
        const emit = __emit;
        const { resetFilter } = useResetFilter(emit);
        const openOnRender = _useModel(__props, 'openOnRender');
        const menuIsVisible = ref(openOnRender.value);
        const { 
        // Data
        displayString, changedValue, selectedType, isSingleFilter, 
        // Computed
        noFilterTextComputed, resetButtonTextComputed, applyButtonTextComputed, 
        // Methods
        typeItemsNumber, typeItemsString, returnTypeId, returnId, returnFilterButtonId, onResetButtonClicked, applyFilters, getDisplayString, emitUpdate, } = useFilter(componentProps, { emit }, modelValue, updateDisplayString);
        const input = ref();
        watch(modelValue, (value) => {
            updateDisplayString(value);
        });
        watch(() => componentProps.type, (value) => {
            updateDisplayString(modelValue.value);
        });
        watch(menuIsVisible, (newValue) => {
            emit('update:openOnRender', newValue);
        });
        watch(openOnRender, (newValue) => {
            menuIsVisible.value = newValue;
        });
        watch(menuIsVisible, async (value) => {
            // Number of ms to finish animation of opening menu
            await sleep(200);
            if (value === true) {
                // input.focus();
            }
        });
        function updateDisplayString(value) {
            displayString.value = getDisplayString(value);
        }
        onBeforeMount(() => {
            updateDisplayString(modelValue.value);
        });
        const __returned__ = { componentProps, t, modelValue, emit, resetFilter, openOnRender, menuIsVisible, displayString, changedValue, selectedType, isSingleFilter, noFilterTextComputed, resetButtonTextComputed, applyButtonTextComputed, typeItemsNumber, typeItemsString, returnTypeId, returnId, returnFilterButtonId, onResetButtonClicked, applyFilters, getDisplayString, emitUpdate, input, updateDisplayString, get EnFilterButtonBase() { return EnFilterButtonBase; }, get EnFilterTypeSelectButton() { return EnFilterTypeSelectButton; }, EnTextField };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
